import { useState } from 'react'
import { Flex, Separator, Spinner } from '@chakra-ui/react'
import { useSearchParams } from 'react-router'
import { useAgendas } from '@/hooks/agendas/useAgendas'
import EmptyAgendas from '@/components/EmptyAgendas'
import AgendaList from './components/AgendaList'
import Header from './components/Header'
import UpsertAgendaDialog from '@/App/Agendas/components/UpsertAgendaDialog'
import type { ViewMode } from './types'
import { STORAGE_KEYS } from '@/utils/storageKeys'

function getInitialView(): ViewMode {
  const stored = localStorage.getItem(STORAGE_KEYS.AGENDAS_VIEW)
  return stored === 'list' ? 'list' : 'grid'
}

const AgendasMain = () => {
  const [searchParams] = useSearchParams()
  const [isDialogOpen, setIsDialogOpen] = useState(
    searchParams.get('de_calendario') === 'criar_agenda'
  )
  const [view, setView] = useState<ViewMode>(getInitialView)

  const handleViewChange = (next: ViewMode) => {
    setView(next)
    localStorage.setItem(STORAGE_KEYS.AGENDAS_VIEW, next)
  }

  const { data: agendas, isLoading } = useAgendas()

  if (isLoading) return <Spinner size="lg" color="primary.500" />

  if (!agendas?.length) return (
    <>
      <Flex flex="1" align="center" justify="center">
        <EmptyAgendas onButtonClick={() => setIsDialogOpen(true)} />
      </Flex>
      <UpsertAgendaDialog open={isDialogOpen} onOpenChange={setIsDialogOpen} />
    </>
  )

  return (
    <Flex direction="column" gap="6" flex="1">
      <Header
        view={view}
        onViewChange={handleViewChange}
        onNewAgenda={() => setIsDialogOpen(true)}
      />

      <Separator />

      <AgendaList agendas={agendas} view={view} />

      <UpsertAgendaDialog open={isDialogOpen} onOpenChange={setIsDialogOpen} />
    </Flex>
  )
}

export default AgendasMain
